<template>
  <button type="button" class="reverse" @click="openHelp(contentId)">도움말</button>
</template>

<script>
export default {
  props: {
    contentId: String
  }
};
</script>

<style></style>
